import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import type { AssignmentPoint } from '@/types/analytics';
import { formatShortDate } from '@/lib/analytics-format';

interface AssignmentsBarChartProps {
  data: AssignmentPoint[];
}

const chartConfig: ChartConfig = {
  created: { label: 'Created', theme: { light: 'var(--chart-2)', dark: 'var(--chart-2)' } },
  completed: { label: 'Completed', theme: { light: 'var(--chart-1)', dark: 'var(--chart-1)' } },
};

export function AssignmentsBarChart({ data }: AssignmentsBarChartProps) {
  const points = data.map((d) => ({ ...d, label: formatShortDate(d.bucket) }));
  return (
    <ChartContainer config={chartConfig} className="h-[240px] w-full">
      <BarChart data={points} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis dataKey="label" tickLine={false} axisLine={false} fontSize={11} />
        <YAxis tickLine={false} axisLine={false} fontSize={11} allowDecimals={false} />
        <ChartTooltip content={<ChartTooltipContent indicator="dot" />} />
        <ChartLegend content={<ChartLegendContent />} />
        <Bar dataKey="created" fill="var(--color-created)" radius={[2, 2, 0, 0]} />
        <Bar dataKey="completed" fill="var(--color-completed)" radius={[2, 2, 0, 0]} />
      </BarChart>
    </ChartContainer>
  );
}
